import React, { useState, useEffect, useContext, useRef } from "react";
import "emoji-mart/css/emoji-mart.css";
import { useParams } from "react-router-dom";
import { Picker } from "emoji-mart";
import MicRecorder from "mic-recorder-to-mp3";
import clsx from "clsx";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import IconButton from "@material-ui/core/IconButton";
import MoreVert from "@material-ui/icons/MoreVert";
import MoodIcon from "@material-ui/icons/Mood";
import SendIcon from "@material-ui/icons/Send";
import ClearIcon from "@material-ui/icons/Clear";
import MicIcon from "@material-ui/icons/Mic";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";

import {
  Hidden,
  Menu,
  MenuItem,
  Switch,
} from "@material-ui/core";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import RecordingTimer from "./RecordingTimer";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { toast } from "react-toastify";
import toastError from "../../errors/toastError";
import { StorefrontOutlined, Search as SearchIcon } from "@material-ui/icons";
import { getBusinessName, getFrontendUrl } from "../../config";
import QuickReplyPicker from "./QuickReplyPicker";
import MediaPreviewDialog from "./MediaPreviewDialog";

const useStyles = makeStyles((theme) => ({
  mainWrapper: {
    background: theme.palette.background.paper,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      bottom: 0,
      width: "100%",
    },
  },

  newMessageBox: {
    background: theme.palette.type === "dark" ? "#424242" : "#eee",
    width: "100%",
    display: "flex",
    padding: "7px",
    alignItems: "center",
  },

  messageInputWrapper: {
    padding: 6,
    background: theme.palette.type === "dark" ? "#4f4e4e" : "#fff",
    display: "flex",
    borderRadius: 20,
    flex: 1,
    position: "relative",
    minWidth: 0,
  },

  messageInput: {
    paddingLeft: 10,
    flex: 1,
    border: "none",
  },

  sendMessageIcons: {
    color: "grey",
  },

  uploadInput: {
    display: "none",
  },

  viewMediaInputWrapper: {
    display: "flex",
    padding: "10px 13px",
    position: "relative",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.background.paper,
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
  },

  emojiBox: {
    position: "absolute",
    bottom: 63,
    width: 40,
    borderTop: "1px solid #e8e8e8",
  },

  circleLoading: {
    color: green[500],
    opacity: "70%",
    position: "absolute",
    top: "20%",
    left: "50%",
    marginLeft: -12,
  },

  audioLoading: {
    color: green[500],
    opacity: "70%",
  },

  recorderWrapper: {
    display: "flex",
    alignItems: "center",
    alignContent: "middle",
  },

  cancelAudioIcon: {
    color: "red",
  },

  sendAudioIcon: {
    color: "green",
  },

  replyginMsgWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 8,
    paddingLeft: 73,
    paddingRight: 7,
  },

  replyginMsgContainer: {
    flex: 1,
    marginRight: 5,
    overflowY: "hidden",
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  replyginMsgBody: {
    padding: 10,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },

  replyginContactMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  replyginSelfMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },

  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },
  storeButton: {
    color: "grey",
  },
  messageInputWithPicker: {
    position: "relative",
    flex: 1,
    display: "flex",
    marginRight: 7,
  },
}));

const MessageInput = ({ ticketStatus, phoneNumber, onSearchClick }) => {
  const classes = useStyles();
  const { ticketId } = useParams();

  const [medias, setMedias] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [loading, setLoading] = useState(false);
  const [recording, setRecording] = useState(false);
  const recorderRef = useRef(null);
  const [typeBar, setTypeBar] = useState(false);
  const inputRef = useRef();
  const [anchorEl, setAnchorEl] = useState(null);
  const [catalogLinkModalOpen, setCatalogLinkModalOpen] = useState(false);
  const [catalogLinkType, setCatalogLinkType] = useState("general");
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [localSearchTerm, setLocalSearchTerm] = useState("");
  const searchInputRef = useRef(null);
  const inputWithPickerRef = useRef(null);

  // Add this effect to maintain focus
  useEffect(() => {
    if (catalogLinkType === "search" && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [catalogLinkType, localSearchTerm]);
  const { setReplyingMessage, replyingMessage } =
    useContext(ReplyMessageContext);



  const { user } = useContext(AuthContext);

  const [signMessage, setSignMessage] = useLocalStorage("signOption", true);
  const [settings, setSettings] = useState([]);

  const fetchCatalogData = async () => {
    try {
      const categoriesResponse = await api.get("/categories");
      setCategories(categoriesResponse.data);

      const productsResponse = await api.get("/products");
      setProducts(productsResponse.data.products);
    } catch (err) {
      toastError(err);
    }
  };

  const handleCloseDialog = () => {
    setCatalogLinkModalOpen(false);
    setLocalSearchTerm("");
  };

  useEffect(() => {
    const fetchSession = async () => {
      try {
        const { data } = await api.get("/settings");
        setSettings(data);
      } catch (err) {
        toastError(err);
      }
    };
    fetchSession();
  }, []);
  const getSettingValue = key => {
    const setting = settings.find(s => s.key === key);
    return setting ? setting.value : "";
  };

  useEffect(() => {
    inputRef.current.focus();
  }, [replyingMessage]);

  useEffect(() => {
    inputRef.current.focus();
    return () => {
      setInputMessage("");
      setShowEmoji(false);
      setMedias([]);
      setReplyingMessage(null);
    };
  }, [ticketId, setReplyingMessage]);

  const typingSentRef = useRef(false);
  const typingIdleRef = useRef(null);

  const notifyTyping = (active) => {
    if (!ticketId) return;
    api.post(`/tickets/${ticketId}/typing`, { typing: !!active }).catch(() => {});
  };

  const stopTyping = () => {
    if (typingIdleRef.current) {
      clearTimeout(typingIdleRef.current);
      typingIdleRef.current = null;
    }
    if (typingSentRef.current) {
      typingSentRef.current = false;
      notifyTyping(false);
    }
  };

  const pulseTyping = () => {
    if (!typingSentRef.current) {
      typingSentRef.current = true;
      notifyTyping(true);
    }
    if (typingIdleRef.current) clearTimeout(typingIdleRef.current);
    typingIdleRef.current = setTimeout(() => {
      typingSentRef.current = false;
      notifyTyping(false);
    }, 3000);
  };

  useEffect(() => {
    return () => {
      stopTyping();
    };
  }, [ticketId]);

  const handleChangeInput = (e) => {
    const value = e.target.value;
    setInputMessage(value);
    if (value === "/") {
      setTypeBar(true);
    } else if (value.indexOf("/") === 0) {
      setTypeBar(true);
    } else {
      setTypeBar(false);
    }
    if (value.trim() && !value.startsWith("/")) {
      pulseTyping();
    } else {
      stopTyping();
    }
  };

  const handleSendCatalogLink = async () => {
    setCatalogLinkModalOpen(true);
    fetchCatalogData();
  };
  const handleSendCatalogLinkConfirm = async () => {
    try {
      setLoading(true);
      const businessName = getBusinessName();
      let catalogUrl = `${getFrontendUrl()}catalog/public?phoneNumber=${phoneNumber}`;
      let messageTitle = `*🛍️ Catálogo - ${businessName}*`;

      switch (catalogLinkType) {
        case "category":
          if (selectedCategory) {
            catalogUrl += `&categoryId=${selectedCategory.id}`;
            messageTitle = `*🛍️ Categoría: ${selectedCategory.name} - ${businessName}*`;
          }
          break;
        case "search":
          if (localSearchTerm) {
            catalogUrl += `&searchTerm=${encodeURIComponent(localSearchTerm)}`;
            messageTitle = `*🛍️ Búsqueda: "${localSearchTerm}" - ${businessName}*`;
          }
          break;
        case "product":
          if (selectedProduct) {
            catalogUrl = `${getFrontendUrl()}catalog/public?productId=${selectedProduct.id}&phoneNumber=${phoneNumber}`;
            messageTitle = `*🛍️ Producto: ${selectedProduct.name} - ${businessName}*`;

            // Add price info if available
            if (selectedProduct.price) {
              const formattedPrice = new Intl.NumberFormat('es-ES', {
                style: 'currency',
                currency: selectedProduct.currency || 'USD'
              }).format(selectedProduct.price);

              messageTitle += `\n💰 Precio: ${formattedPrice}`;
            }
          }
          break;
        default:
          // General catalog link (no changes needed)
          break;
      }

      const message = {
        read: 1,
        fromMe: true,
        mediaUrl: "",
        body: `${messageTitle}\n${catalogUrl}`
      };

      await api.post(`/messages/${ticketId}`, message);
      setLoading(false);
      handleCloseDialog();

      // Reset all selections
      setCatalogLinkType("general");
      setSelectedCategory(null);
      setSelectedProduct(null);
      setLocalSearchTerm(""); // Reset only after successful send

    } catch (err) {
      toastError(err);
      setLoading(false);
    }
  };

  const handleAddEmoji = (e) => {
    let emoji = e.native;
    setInputMessage((prevState) => prevState + emoji);
  };

  const handleChangeMedias = (e) => {
    if (!e.target.files) {
      return;
    }

    const selectedMedias = Array.from(e.target.files);
    setMedias(selectedMedias);
    // Allow picking the same file again later
    e.target.value = "";
  };

  const handleInputPaste = (e) => {
    const files = Array.from(e.clipboardData.files || []);
    if (files.length) {
      setMedias(files);
    }
  };

  const handleUploadMedia = async (captions = []) => {
    setLoading(true);

    const formData = new FormData();
    formData.append("fromMe", true);
    const fileCaptions = medias.map((media, index) => {
      const caption = captions[index] || "";
      if (caption) return caption;
      // Documents keep their file name as body so the chat shows it
      return /^(image|video|audio)\//.test(media.type || "") ? "" : media.name;
    });
    medias.forEach((media) => {
      formData.append("medias", media);
    });
    formData.append("body", fileCaptions[0] || "");
    formData.append("captions", JSON.stringify(fileCaptions));

    try {
      stopTyping();
      await api.post(`/messages/${ticketId}`, formData);
    } catch (err) {
      toastError(err);
    }

    setLoading(false);
    setMedias([]);
  };

  const handleSendMessage = async () => {
    if (inputMessage.trim() === "") return;
    setLoading(true);

    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: signMessage
        ? `*${user?.name}:*\n${inputMessage.trim()}`
        : inputMessage.trim(),
      quotedMsg: replyingMessage,
    };
    try {
      stopTyping();
      await api.post(`/messages/${ticketId}`, message);
    } catch (err) {
      toastError(err);
    }

    setInputMessage("");
    setShowEmoji(false);
    setLoading(false);
    setReplyingMessage(null);
  };

  const handleStartRecording = async () => {
    setLoading(true);
    try {
      if (!navigator.mediaDevices?.getUserMedia) {
        throw new Error(i18n.t("messagesInput.audioUnsupported"));
      }
      await navigator.mediaDevices.getUserMedia({ audio: true });
      recorderRef.current = new MicRecorder({ bitRate: 128 });
      await recorderRef.current.start();
      setRecording(true);
      setLoading(false);
    } catch (err) {
      recorderRef.current = null;
      toast.error(i18n.t("messagesInput.audioMicError"));
      setLoading(false);
    }
  };


  const handleUploadAudio = async () => {
    setLoading(true);
    try {
      const recorder = recorderRef.current;
      if (!recorder) {
        throw new Error(i18n.t("messagesInput.audioMicError"));
      }
      const [, rawBlob] = await recorder.stop().getMp3();
      recorderRef.current = null;
      const blob =
        rawBlob && rawBlob.type
          ? rawBlob
          : new Blob([rawBlob], { type: "audio/mpeg" });
      if (!blob || blob.size < 10000) {
        toast.error(i18n.t("messagesInput.audioTooShort"));
        setLoading(false);
        setRecording(false);
        return;
      }

      const formData = new FormData();
      const filename = `${new Date().getTime()}.mp3`;
      formData.append("medias", blob, filename);
      formData.append("body", filename);
      formData.append("fromMe", true);

      await api.post(`/messages/${ticketId}`, formData);
    } catch (err) {
      recorderRef.current = null;
      toastError(err);
    }

    setRecording(false);
    setLoading(false);
  };

  const handleCancelAudio = async () => {
    try {
      if (recorderRef.current) {
        await recorderRef.current.stop().getMp3();
      }
      recorderRef.current = null;
      setRecording(false);
    } catch (err) {
      recorderRef.current = null;
      setRecording(false);
      toastError(err);
    }
  };

  const handleOpenMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event) => {
    setAnchorEl(null);
  };

  const renderReplyingMessage = (message) => {
    return (
      <div className={classes.replyginMsgWrapper}>
        <div className={classes.replyginMsgContainer}>
          <span
            className={clsx(classes.replyginContactMsgSideColor, {
              [classes.replyginSelfMsgSideColor]: !message.fromMe,
            })}
          ></span>
          <div className={classes.replyginMsgBody}>
            {!message.fromMe && (
              <span className={classes.messageContactName}>
                {message.nameUser || message.contact?.name}
              </span>
            )}
            {message.body}
          </div>
        </div>
        <IconButton
          aria-label="showRecorder"
          component="span"
          disabled={loading || ticketStatus !== "open"}
          onClick={() => setReplyingMessage(null)}
        >
          <ClearIcon className={classes.sendMessageIcons} />
        </IconButton>
      </div>
    );
  };

  const renderCatalogLinkDialog = () => {
    return (
      <Dialog
        open={catalogLinkModalOpen}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Enviar link del catálogo</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset">
            <FormLabel component="legend">Tipo de link</FormLabel>
            <RadioGroup
              value={catalogLinkType}
              onChange={(e) => {
                setCatalogLinkType(e.target.value);
                setSelectedCategory(null);
                setSelectedProduct(null);
              }}
            >
              <FormControlLabel
                value="general"
                control={<Radio />}
                label="Catálogo general"
              />
              <FormControlLabel
                value="category"
                control={<Radio />}
                label="Categoría específica"
              />
              <FormControlLabel
                value="search"
                control={<Radio />}
                label="Término de búsqueda"
              />
              <FormControlLabel
                value="product"
                control={<Radio />}
                label="Producto específico"
              />
            </RadioGroup>
          </FormControl>

          {catalogLinkType === "category" && (
            <Autocomplete
              style={{ marginTop: 16 }}
              options={categories}
              getOptionLabel={(option) => option.name}
              value={selectedCategory}
              onChange={(event, newValue) => {
                setSelectedCategory(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Seleccionar categoría"
                  variant="outlined"
                  fullWidth
                />
              )}
            />
          )}

          {catalogLinkType === "search" && (
            <TextField
              style={{ marginTop: 16 }}
              label="Término de búsqueda"
              value={localSearchTerm}
              inputRef={searchInputRef}
              onChange={(e) => {
                // Create a new event instead of mutating the original
                const value = e.target.value;
                setLocalSearchTerm(value);
              }}
              variant="outlined"
              fullWidth
              inputProps={{
                autoFocus: catalogLinkType === "search"
              }}
            />
          )}

          {catalogLinkType === "product" && (
            <Autocomplete
              style={{ marginTop: 16 }}
              options={products}
              getOptionLabel={(option) => `${option.name} (ID: ${option.id})`}
              value={selectedProduct}
              onChange={(event, newValue) => {
                setSelectedProduct(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Seleccionar producto"
                  variant="outlined"
                  fullWidth
                />
              )}
              renderOption={(option) => (
                <div>
                  <Typography variant="body1">{option.name}</Typography>
                  <Typography variant="body2" color="textSecondary">
                    {new Intl.NumberFormat('es-ES', {
                      style: 'currency',
                      currency: option.currency || 'USD'
                    }).format(option.price)}
                  </Typography>
                </div>
              )}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseDialog}
            color="default"
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSendCatalogLinkConfirm}
            color="primary"
            variant="contained"
            disabled={
              (catalogLinkType === "category" && !selectedCategory) ||
              (catalogLinkType === "search" && !localSearchTerm) ||
              (catalogLinkType === "product" && !selectedProduct)
            }
          >
            Enviar
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  if (medias.length > 0)
    return (
      <MediaPreviewDialog
        medias={medias}
        loading={loading}
        onAdd={(files) => setMedias((prev) => [...prev, ...files])}
        onRemove={(index) => setMedias((prev) => prev.filter((_, i) => i !== index))}
        onCancel={() => setMedias([])}
        onSend={handleUploadMedia}
      />
    );
  else {
    return (
      <>
        <Paper square elevation={0} className={classes.mainWrapper}>
          {replyingMessage && renderReplyingMessage(replyingMessage)}
          <div className={classes.newMessageBox}>
            <Hidden only={["sm", "xs"]}>
              {onSearchClick && (
                <IconButton
                  aria-label="search"
                  onClick={onSearchClick}
                  title={i18n.t("tickets.search.inChat") || "Buscar en chat"}
                  disabled={loading || recording}
                >
                  <SearchIcon className={classes.sendMessageIcons} />
                </IconButton>
              )}
              <IconButton
                aria-label="emojiPicker"
                component="span"
                disabled={loading || recording || ticketStatus !== "open"}
                onClick={(e) => setShowEmoji((prevState) => !prevState)}
              >
                <MoodIcon className={classes.sendMessageIcons} />
              </IconButton>
              {showEmoji ? (
                <div className={classes.emojiBox}>
                  <ClickAwayListener onClickAway={(e) => setShowEmoji(false)}>
                    <Picker
                      perLine={16}
                      showPreview={false}
                      showSkinTones={false}
                      onSelect={handleAddEmoji}
                    />
                  </ClickAwayListener>
                </div>
              ) : null}

              <input
                multiple
                type="file"
                id="upload-button"
                disabled={loading || recording || ticketStatus !== "open"}
                className={classes.uploadInput}
                onChange={handleChangeMedias}
              />
              <label htmlFor="upload-button">
                <IconButton
                  aria-label="upload"
                  component="span"
                  disabled={loading || recording || ticketStatus !== "open"}
                >
                  <AttachFileIcon className={classes.sendMessageIcons} />
                </IconButton>
              </label>
              {getSettingValue("storeEnabled") === "enabled" && (
                <IconButton
                  aria-label="sendCatalog"
                  component="span"
                  disabled={loading || recording || ticketStatus !== "open"}
                  onClick={handleSendCatalogLink}
                >
                  <StorefrontOutlined className={classes.storeButton} />
                </IconButton>
              )}
              <FormControlLabel
                style={{ marginRight: 7, color: "gray" }}
                label={i18n.t("messagesInput.signMessage")}
                labelPlacement="start"
                control={
                  <Switch
                    size="small"
                    checked={signMessage}
                    onChange={(e) => {
                      setSignMessage(e.target.checked);
                    }}
                    name="showAllTickets"
                    color="primary"
                  />
                }
              />
            </Hidden>
            <Hidden only={["md", "lg", "xl"]}>
              {onSearchClick && (
                <IconButton
                  aria-label="search"
                  onClick={onSearchClick}
                  title={i18n.t("tickets.search.inChat") || "Buscar en chat"}
                  disabled={loading || recording}
                >
                  <SearchIcon className={classes.sendMessageIcons} />
                </IconButton>
              )}
              <IconButton
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleOpenMenuClick}
              >
                <MoreVert></MoreVert>
              </IconButton>
              <Menu
                id="simple-menu"
                keepMounted
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuItemClick}
              >
                {onSearchClick && (
                  <MenuItem onClick={() => { handleMenuItemClick(); onSearchClick(); }}>
                    <IconButton aria-label="search" component="span">
                      <SearchIcon className={classes.sendMessageIcons} />
                    </IconButton>
                    <span style={{ marginLeft: 8 }}>{i18n.t("tickets.search.inChat") || "Buscar en chat"}</span>
                  </MenuItem>
                )}
                <MenuItem onClick={handleMenuItemClick}>
                  <IconButton
                    aria-label="emojiPicker"
                    component="span"
                    disabled={loading || recording || ticketStatus !== "open"}
                    onClick={(e) => setShowEmoji((prevState) => !prevState)}
                  >
                    <MoodIcon className={classes.sendMessageIcons} />
                  </IconButton>
                </MenuItem>
                <MenuItem onClick={handleMenuItemClick}>
                  <input
                    multiple
                    type="file"
                    id="upload-button"
                    disabled={loading || recording || ticketStatus !== "open"}
                    className={classes.uploadInput}
                    onChange={handleChangeMedias}
                  />
                  <label htmlFor="upload-button">
                    <IconButton
                      aria-label="upload"
                      component="span"
                      disabled={loading || recording || ticketStatus !== "open"}
                    >
                      <AttachFileIcon className={classes.sendMessageIcons} />
                    </IconButton>
                  </label>
                </MenuItem>
                <MenuItem onClick={handleMenuItemClick}>
                  <FormControlLabel
                    style={{ marginRight: 7, color: "gray" }}
                    label={i18n.t("messagesInput.signMessage")}
                    labelPlacement="start"
                    control={
                      <Switch
                        size="small"
                        checked={signMessage}
                        onChange={(e) => {
                          setSignMessage(e.target.checked);
                        }}
                        name="showAllTickets"
                        color="primary"
                      />
                    }
                  />
                </MenuItem>
                {getSettingValue("storeEnabled") === "enabled" && (
                  <MenuItem onClick={handleMenuItemClick}>
                    <IconButton
                      aria-label="sendCatalog"
                      component="span"
                      disabled={loading || recording || ticketStatus !== "open"}
                      onClick={handleSendCatalogLink}
                    >
                      <StorefrontOutlined className={classes.storeButton} />
                    </IconButton>
                  </MenuItem>
                )}
              </Menu>
            </Hidden>
            <div className={classes.messageInputWithPicker} ref={inputWithPickerRef}>
              <div className={classes.messageInputWrapper}>
                <InputBase
                  inputRef={(input) => {
                    input && input.focus();
                    input && (inputRef.current = input);
                  }}
                  className={classes.messageInput}
                  placeholder={
                    ticketStatus === "open"
                      ? i18n.t("messagesInput.placeholderOpen")
                      : i18n.t("messagesInput.placeholderClosed")
                  }
                  multiline
                  maxRows={5}
                  value={inputMessage}
                  onChange={handleChangeInput}
                  disabled={recording || loading || ticketStatus !== "open"}
                  onPaste={(e) => {
                    ticketStatus === "open" && handleInputPaste(e);
                  }}
                  onKeyDown={(e) => {
                    if (loading) return;
                    if (typeBar && e.key === "Escape") {
                      setTypeBar(false);
                      return;
                    }
                    // Enter: send message. Shift+Enter: new line.
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      handleSendMessage();
                    }
                  }}
                />
              </div>
            </div>
            {inputMessage ? (
              <IconButton
                aria-label="sendMessage"
                component="span"
                onClick={handleSendMessage}
                disabled={loading}
              >
                <SendIcon className={classes.sendMessageIcons} />
              </IconButton>
            ) : recording ? (
              <div className={classes.recorderWrapper}>
                <IconButton
                  aria-label="cancelRecording"
                  component="span"
                  fontSize="large"
                  disabled={loading}
                  onClick={handleCancelAudio}
                >
                  <HighlightOffIcon className={classes.cancelAudioIcon} />
                </IconButton>
                {loading ? (
                  <div>
                    <CircularProgress className={classes.audioLoading} />
                  </div>
                ) : (
                  <RecordingTimer />
                )}

                <IconButton
                  aria-label="sendRecordedAudio"
                  component="span"
                  onClick={handleUploadAudio}
                  disabled={loading}
                >
                  <CheckCircleOutlineIcon className={classes.sendAudioIcon} />
                </IconButton>
              </div>
            ) : (
              <IconButton
                aria-label="showRecorder"
                component="span"
                disabled={loading || ticketStatus !== "open"}
                onClick={handleStartRecording}
              >
                <MicIcon className={classes.sendMessageIcons} />
              </IconButton>
            )}
          </div>
        </Paper>
        {renderCatalogLinkDialog()}
        <QuickReplyPicker
          open={typeBar}
          searchTerm={inputMessage.startsWith("/") ? inputMessage.slice(1).trim() : ""}
          onClose={() => setTypeBar(false)}
          onSelectText={(msg) => {
            setInputMessage(msg);
            setTypeBar(false);
          }}
          onSelectQuickReply={() => {
            setInputMessage("");
            setTypeBar(false);
          }}
          ticketId={ticketId}
        />
      </>
    );
  }
};

export default MessageInput;